import { useMemo, useState } from "react";
import {
    HighlightsStatsSection,
    type HighlightMetricId,
} from "../../components/highlights/HighlightsStatsSection";
import { getCurrentMonthDateRangeLocal } from "../../utils/dateRange";

const INVESTOR_EXCLUDED_HIGHLIGHT_METRICS: readonly HighlightMetricId[] = [
    "approaches",
    "attended",
    "tomorrow",
    "subJobs",
];

const InvestorDashboardPage = () => {
    const monthDefault = useMemo(() => getCurrentMonthDateRangeLocal(), []);
    const [startDate, setStartDate] = useState(monthDefault.startDate);
    const [endDate, setEndDate] = useState(monthDefault.endDate);

    return (
        <div className="min-h-screen bg-slate-50">
            <div className="mx-auto w-full max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
                <HighlightsStatsSection
                    startDate={startDate}
                    endDate={endDate}
                    onStartDateChange={setStartDate}
                    onEndDateChange={setEndDate}
                    cardTitle="Your Highlights"
                    showAggregateHints={false}
                    excludedMetricIds={INVESTOR_EXCLUDED_HIGHLIGHT_METRICS}
                    showUsersMetric
                />
            </div>
        </div>
    );
};

export default InvestorDashboardPage;
